import script from "./VideoClip.vue?vue&type=script&setup=true&lang=ts"
export * from "./VideoClip.vue?vue&type=script&setup=true&lang=ts"

import "./VideoClip.vue?vue&type=style&index=0&id=8173b93a&lang=less&scoped=true"

import exportComponent from "/Users/neal/www/bonwey/qingtv-back-new/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8173b93a"]])

export default __exports__